import { jsx as s, jsxs as C } from "react/jsx-runtime";
import { useMemo as p } from "react";
import { classes as M } from "../../utils/styles.js";
import { useTranslation as _ } from "../../hooks/useTranslation.js";
import "../Context/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import r from "./nutritionalattributehighlights.module.js";
import { AttributeHighlight as v } from "./shared.js";
import "../ProductTable/TableRowGroup.js";
import { NutrientClaimTypeCodes as E } from "../../types/types.js";
import { transformNutritionalClaims as j } from "../../utils/transformation.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import { supportedAttributes as b } from "./supportedAttributes.js";
const I = ({
  productData: n,
  isHidden: N = !1,
  containerClassName: y,
  language: h
}) => {
  const { tryTranslate: o } = _(), u = p(
    () => !!n && j(n, o, h) || {},
    [n, o, h]
  ), g = p(
    () => {
      var t;
      return (t = n == null ? void 0 : n.diets) == null ? void 0 : t.map((l) => l.diet_types);
    },
    [n]
  ), f = p(
    () => {
      var t, l;
      return (l = (t = n == null ? void 0 : n.packaging_markings) == null ? void 0 : t[0]) == null ? void 0 : l.packaging_marked_label_accreditation_code;
    },
    [n]
  ), k = f ? f.split("; ") : [], a = p(() => {
    const t = [], l = [];
    for (const [i, m] of Object.entries(u)) {
      const d = m.filter((e) => b[e.translationKey]).map((e, c) => /* @__PURE__ */ s(
        v,
        {
          name: e.translationKey,
          label: e.value
        },
        `${i}-${c}`
      ));
      d.length > 0 && t.push(
        /* @__PURE__ */ s("div", { className: r.highlightContainer, children: d }, i)
      );
    }
    return g != null && g.length && t.push(
      /* @__PURE__ */ s("div", { className: r.highlightContainer, children: g.map((i) => {
        const m = i.filter(
          (e) => e.language === h
        );
        return (m.length ? m : i.filter((e) => e.language === "fi")).map((e, c) => Object.values(E).includes(e.code) ? /* @__PURE__ */ s("div", { children: e.value && /* @__PURE__ */ s(
          v,
          {
            name: e.code,
            label: o(e.code) || e.value
          },
          "diet" + c
        ) }, "diet" + c) : null);
      }) }, "dietTypes")
    ), k.length > 0 && k.some(
      (i) => b.hasOwnProperty(i)
    ) && l.push(
      /* @__PURE__ */ s("div", { className: r.highlightContainer, children: k.filter((i) => b.hasOwnProperty(i)).map((i, m) => /* @__PURE__ */ s(
        v,
        {
          name: i,
          label: o(i) || i
        },
        "marking" + m
      )) }, "packagingMarkings")
    ), { elements: t, packagingMarkingsElements: l };
  }, [u, g, f, o, h]);
  return a.elements.length === 0 && a.packagingMarkingsElements.length === 0 ? null : /* @__PURE__ */ s("div", { className: y, children: /* @__PURE__ */ C(
    "div",
    {
      className: M([
        r.container,
        ...N ? [r.hidden] : []
      ]),
      children: [
        a.elements.length > 0 && /* @__PURE__ */ s("div", { className: r.elements, children: a.elements }),
        a.packagingMarkingsElements.length > 0 && /* @__PURE__ */ s("div", { className: r.elements, children: a.packagingMarkingsElements })
      ]
    }
  ) });
};
export {
  I as NutritionalAttributeHighlights
};
